import styled from 'styled-components';
import {
  MINIMUM_FOOTER_HEIGHT_PX,
  SITE_HEADER_HEIGHT_PX,
  spacingHelper,
} from '@property.com.au/ui-kit';

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${spacingHelper('large')} auto;
  row-gap: ${spacingHelper('large')};
  padding-top: ${SITE_HEADER_HEIGHT_PX}px;
  min-height: calc(100vh - ${MINIMUM_FOOTER_HEIGHT_PX}px);
  max-width: 1920px;
`;
